import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class BaseFormService {

 public pagination = {
    rows: [],
    currentPageApi: 0,
    currentPagePaginator: 1,
    pageSize: 6 as string | number,
    totalElements: 100,
    totalPages: 0,
    search: null
  }

  constructor() { }

  getIdImportacaoLocalStorage(): string {
    return localStorage.getItem('idImportacao') ?? "2368523";
  }

  // ID fixo adicionado para teste caso não retorne nenhum ID de empresa no LocalStorage
  getIdEmpresaLocalStorage(): string {
    return localStorage.getItem('idEmpresaLogada') ?? "750315";
  }
  setIdEmpresaLocalStorage(empresa): string {
    localStorage.setItem('idEmpresaLogada', empresa);
    return empresa;
  }

  /** método responsável por criar os parâmetros (query params) na URL da paginação
   *
   * Um parâmetro é um  array de  objeto -> [ {  name: <> , comparator : <> , value : <>} ]
  */
  public getParamsUrl(params) {

    let str = ``;

    /**se exsitir algum parâmetro */
    if (params.length > 0) {
      str += `?`;

      /**para cada parâmetro que devemos colocar na URL */
      params.forEach(el => {
        str += `${el.name}${el.comparator}${el.value}&`
      });

      /** para retirar o último & da URL */
      str = str.substring(0, str.length - 1);
    }

    return str;
  }

  /** data são os dados vindos da API
   *
   * number: 0
    size: 10
    sort: "UNSORTED"
    total: 4
   *
  */
  public setPagination( res ) {

    this.pagination.rows = res.response?.data;
    this.pagination.totalPages = res.response?.pageRequest.total ;
    this.pagination.currentPageApi = res.response?.pageRequest.page;
    this.pagination.currentPagePaginator = this.pagination.currentPageApi + 1;
    this.pagination.pageSize = res.response?.pageRequest.size;
    this.pagination.totalElements = (res.response?.pageRequest.total);

    if (res.response?.data.length == 0){
      this.setDefaultPagination();
    }
  }

  getPage(page: number ) {

    this.pagination.currentPagePaginator = page;
    this.pagination.currentPageApi = page - 1;

    this.getApiData();
  }

  public onPageSizeChange(newSize) {

    this.pagination.pageSize = newSize;
    this.getApiData();
  }

  public getApiData() { /* intencionalmente vazio */ }

  public pageChanged(event) { /* intencionalmente vazio */ }

  public setDefaultPagination(){
    this.pagination = {
      rows: [],
      currentPageApi: 0,
      currentPagePaginator: 1,
      pageSize: 6,
      totalElements: 0,
      totalPages: 0,
      search: null
    };
  }

  mapearResultados(objeto: any, idObjeto: any, descricaoObjeto: any) {
    return objeto.map(obj => {
      return {
        id: obj[idObjeto],
        label: obj[descricaoObjeto]
      };
    });
  }

  /**
   * Atualiza a paginação local com base no pageInfo retornado pela API.
   * Usado por componentes que seguem o padrão { pagina, tamanho, totalPaginas, totalRegistros }.
   */
  setPaginacaoLocal(res: any, paginationTotal: any): void {
    this.pagination.totalPages = paginationTotal.totalPaginas;
    this.pagination.currentPageApi = paginationTotal.pagina;
    this.pagination.currentPagePaginator = paginationTotal.pagina + 1;
    this.pagination.pageSize = paginationTotal.tamanho;
    this.pagination.totalElements = paginationTotal.totalRegistros;
    if (res.response?.pageInfo?.pagina === 0) {
      this.pagination.currentPageApi = 0;
    }
  }

}
